var map = {
	"./1": 124,
	"./1.png": 124,
	"./2": 125,
	"./2.png": 125,
	"./3": 126,
	"./3.png": 126,
	"./4": 127,
	"./4.png": 127,
	"./about": 128,
	"./about.png": 128,
	"./activity": 227,
	"./activity.svg": 227,
	"./add-cta": 295,
	"./add-cta-active": 296,
	"./add-cta-active.svg": 296,
	"./add-cta.svg": 295,
	"./added-to-collections-active": 297,
	"./added-to-collections-active.svg": 297,
	"./adobe": 129,
	"./adobe.png": 129,
	"./analytics": 108,
	"./analytics.svg": 108,
	"./annotate": 298,
	"./annotate-active": 299,
	"./annotate-active.svg": 299,
	"./annotate.svg": 298,
	"./annotate/arrow": 261,
	"./annotate/arrow.svg": 261,
	"./annotate/crop": 262,
	"./annotate/crop.svg": 262,
	"./annotate/draw": 263,
	"./annotate/draw.svg": 263,
	"./annotate/ellipse": 264,
	"./annotate/ellipse-focus": 265,
	"./annotate/ellipse-focus.svg": 265,
	"./annotate/ellipse.svg": 264,
	"./annotate/emoji": 112,
	"./annotate/emoji.png": 112,
	"./annotate/emoji@2x": 113,
	"./annotate/emoji@2x.png": 113,
	"./annotate/emoji@3x": 114,
	"./annotate/emoji@3x.png": 114,
	"./annotate/highlighter": 266,
	"./annotate/highlighter.svg": 266,
	"./annotate/line": 267,
	"./annotate/line.svg": 267,
	"./annotate/number": 268,
	"./annotate/number.svg": 268,
	"./annotate/pixelate": 269,
	"./annotate/pixelate.svg": 269,
	"./annotate/rect": 270,
	"./annotate/rect.svg": 270,
	"./annotate/square-focus": 271,
	"./annotate/square-focus.svg": 271,
	"./annotate/text": 272,
	"./annotate/text.svg": 272,
	"./annotate/tools-history-back": 273,
	"./annotate/tools-history-back-disabled": 274,
	"./annotate/tools-history-back-disabled.svg": 274,
	"./annotate/tools-history-back.svg": 273,
	"./annotate/tools-history-forward": 275,
	"./annotate/tools-history-forward-disabled": 276,
	"./annotate/tools-history-forward-disabled.svg": 276,
	"./annotate/tools-history-forward.svg": 275,
	"./annotate/tools-zoom-zoom-in": 258,
	"./annotate/tools-zoom-zoom-in.svg": 258,
	"./annotate/tools-zoom-zoom-out": 259,
	"./annotate/tools-zoom-zoom-out.svg": 259,
	"./app-icon": 300,
	"./app-icon.svg": 300,
	"./apple": 301,
	"./apple.svg": 301,
	"./apple_logo": 214,
	"./apple_logo.svg": 214,
	"./arrow-big": 130,
	"./arrow-big.png": 130,
	"./atlassian": 131,
	"./atlassian.png": 131,
	"./bg-bottom": 132,
	"./bg-bottom.png": 132,
	"./bg-top": 133,
	"./bg-top.png": 133,
	"./bill": 302,
	"./bill.svg": 302,
	"./blurred-drop": 87,
	"./blurred-drop.png": 87,
	"./branding": 99,
	"./branding.svg": 99,
	"./buttons-add-new-collection-hover": 303,
	"./buttons-add-new-collection-hover.svg": 303,
	"./buttons-add-new-collection-sidebar": 304,
	"./buttons-add-new-collection-sidebar.svg": 304,
	"./card-generic": 100,
	"./card-generic.png": 100,
	"./check-mark": 305,
	"./check-mark.svg": 305,
	"./checkmark": 306,
	"./checkmark.svg": 306,
	"./checkmark@2x": 134,
	"./checkmark@2x.png": 134,
	"./chrome": 307,
	"./chrome.svg": 307,
	"./close": 279,
	"./close.svg": 279,
	"./cloud-loader": 243,
	"./cloud-loader.gif": 243,
	"./cloudapp": 135,
	"./cloudapp-favicon": 136,
	"./cloudapp-favicon.png": 136,
	"./cloudapp-icon": 137,
	"./cloudapp-icon.png": 137,
	"./cloudapp-logo-horizontal": 205,
	"./cloudapp-logo-horizontal.svg": 205,
	"./cloudapp.png": 135,
	"./coach-mark": 308,
	"./coach-mark.svg": 308,
	"./collection": 206,
	"./collection.svg": 206,
	"./conversation": 309,
	"./conversation.svg": 309,
	"./dashboard": 228,
	"./dashboard.svg": 228,
	"./download-arrow": 310,
	"./download-arrow.svg": 310,
	"./download-chrome": 311,
	"./download-chrome.svg": 311,
	"./download-cloud": 312,
	"./download-cloud.svg": 312,
	"./download-drop": 313,
	"./download-drop.svg": 313,
	"./download-mac": 314,
	"./download-mac.svg": 314,
	"./download-windows": 315,
	"./download-windows.svg": 315,
	"./download_icon_chrome": 316,
	"./download_icon_chrome.svg": 316,
	"./download_icon_mac": 317,
	"./download_icon_mac.svg": 317,
	"./download_icon_windows": 318,
	"./download_icon_windows.svg": 318,
	"./email": 215,
	"./email.svg": 215,
	"./enterprise@2x": 138,
	"./enterprise@2x.png": 138,
	"./file-placeholder": 277,
	"./file-placeholder.svg": 277,
	"./free@2x": 139,
	"./free@2x.png": 139,
	"./free_plan_icon": 140,
	"./free_plan_icon.png": 140,
	"./gift": 244,
	"./gift.svg": 244,
	"./google_logo": 216,
	"./google_logo.svg": 216,
	"./hat-icon": 319,
	"./hat-icon.svg": 319,
	"./hero-asset": 88,
	"./hero-asset.gif": 474,
	"./hero-asset.png": 88,
	"./icon-clock": 217,
	"./icon-clock.jpeg": 217,
	"./icon-get-cloudapp": 182,
	"./icon-get-cloudapp.svg": 182,
	"./icon-muted": 278,
	"./icon-muted.svg": 278,
	"./icon-muted@2x": 141,
	"./icon-muted@2x.png": 141,
	"./icons-add": 245,
	"./icons-add-bordered": 142,
	"./icons-add-bordered.png": 142,
	"./icons-add-to-collection-solid": 320,
	"./icons-add-to-collection-solid.svg": 320,
	"./icons-add.svg": 245,
	"./icons-announcement": 321,
	"./icons-announcement.svg": 321,
	"./icons-bug": 322,
	"./icons-bug.svg": 322,
	"./icons-card-actions-compact-read-only": 101,
	"./icons-card-actions-compact-read-only.svg": 101,
	"./icons-clipboard": 236,
	"./icons-clipboard.svg": 236,
	"./icons-close": 260,
	"./icons-close.svg": 260,
	"./icons-conversation": 109,
	"./icons-conversation.svg": 109,
	"./icons-download-bordered": 143,
	"./icons-download-bordered.png": 143,
	"./icons-download-solid": 323,
	"./icons-download-solid.svg": 323,
	"./icons-edit-minimal": 218,
	"./icons-edit-minimal.svg": 218,
	"./icons-embed-bordered": 144,
	"./icons-embed-bordered.png": 144,
	"./icons-embed-solid": 324,
	"./icons-embed-solid.svg": 324,
	"./icons-hidden": 325,
	"./icons-hidden.svg": 325,
	"./icons-invite-active": 229,
	"./icons-invite-active.svg": 229,
	"./icons-invite-default": 230,
	"./icons-invite-default.svg": 230,
	"./icons-locked-bordered": 145,
	"./icons-locked-bordered.png": 145,
	"./icons-magic": 326,
	"./icons-magic.svg": 326,
	"./icons-mouse-click": 327,
	"./icons-mouse-click-gray": 328,
	"./icons-mouse-click-gray.svg": 328,
	"./icons-mouse-click.svg": 327,
	"./icons-new": 146,
	"./icons-new-gray": 246,
	"./icons-new-gray.svg": 246,
	"./icons-new-transparent": 247,
	"./icons-new-transparent.svg": 247,
	"./icons-new-white": 248,
	"./icons-new-white.svg": 248,
	"./icons-new.svg": 146,
	"./icons-notifications": 110,
	"./icons-notifications-active": 111,
	"./icons-notifications-active.svg": 111,
	"./icons-notifications.svg": 110,
	"./icons-rainbow-circle": 147,
	"./icons-rainbow-circle.png": 147,
	"./icons-rounded-corners": 329,
	"./icons-rounded-corners.svg": 329,
	"./icons-sales": 330,
	"./icons-sales.svg": 330,
	"./icons-search": 331,
	"./icons-search.svg": 331,
	"./icons-settings-blue": 249,
	"./icons-settings-blue.svg": 249,
	"./icons-settings-gray": 219,
	"./icons-settings-gray.svg": 219,
	"./icons-share-settings-locked": 332,
	"./icons-share-settings-locked.svg": 332,
	"./icons-slightly-rounded-corners": 333,
	"./icons-slightly-rounded-corners.svg": 333,
	"./icons-square-corners": 334,
	"./icons-square-corners.svg": 334,
	"./icons-support": 335,
	"./icons-support.svg": 335,
	"./icons-toggle-close": 250,
	"./icons-toggle-close.svg": 250,
	"./icons-toggle-open": 251,
	"./icons-toggle-open.svg": 251,
	"./icons-transcribe": 220,
	"./icons-transcribe.svg": 220,
	"./illustrations-transcription-processing": 252,
	"./illustrations-transcription-processing.svg": 252,
	"./indicator-right": 336,
	"./indicator-right.svg": 336,
	"./infinite": 102,
	"./infinite.svg": 102,
	"./installer": 337,
	"./installer.svg": 337,
	"./logo-visa": 338,
	"./logo-visa.jpeg": 338,
	"./logo@2x": 80,
	"./logo@2x-blue": 148,
	"./logo@2x-blue.png": 148,
	"./logo@2x.png": 80,
	"./logos-cloud-app-logomark-full-color": 221,
	"./logos-cloud-app-logomark-full-color.svg": 221,
	"./main-banner": 149,
	"./main-banner.png": 149,
	"./menu-bar": 339,
	"./menu-bar.svg": 339,
	"./onboarding/apple": 183,
	"./onboarding/apple.svg": 183,
	"./onboarding/bill": 150,
	"./onboarding/bill.svg": 150,
	"./onboarding/chrome": 184,
	"./onboarding/chrome.svg": 184,
	"./onboarding/download-arrow": 185,
	"./onboarding/download-arrow.svg": 185,
	"./onboarding/download-chrome": 186,
	"./onboarding/download-chrome.svg": 186,
	"./onboarding/download-drop": 187,
	"./onboarding/download-drop.svg": 187,
	"./onboarding/download-mac": 188,
	"./onboarding/download-mac.svg": 188,
	"./onboarding/download-windows": 189,
	"./onboarding/download-windows.svg": 189,
	"./onboarding/email": 151,
	"./onboarding/email.svg": 151,
	"./onboarding/hat-icon": 190,
	"./onboarding/hat-icon.svg": 190,
	"./onboarding/icons-check": 103,
	"./onboarding/icons-check.svg": 103,
	"./onboarding/icons-chrome-desaturated": 191,
	"./onboarding/icons-chrome-desaturated.svg": 191,
	"./onboarding/icons-cloud-app-app": 192,
	"./onboarding/icons-cloud-app-app.svg": 192,
	"./onboarding/icons-download": 152,
	"./onboarding/icons-download.svg": 152,
	"./onboarding/icons-extension": 153,
	"./onboarding/icons-extension.svg": 153,
	"./onboarding/installer": 193,
	"./onboarding/installer.svg": 193,
	"./onboarding/menu-bar": 194,
	"./onboarding/menu-bar.svg": 194,
	"./onboarding/start": 154,
	"./onboarding/start.svg": 154,
	"./onboarding/windows": 195,
	"./onboarding/windows.svg": 195,
	"./parallax": 340,
	"./parallax.jpg": 340,
	"./pattern": 155,
	"./pattern-2": 156,
	"./pattern-2.png": 156,
	"./pattern-4": 157,
	"./pattern-4.png": 157,
	"./pattern.png": 155,
	"./plus": 341,
	"./plus-small": 342,
	"./plus-small.svg": 342,
	"./plus.svg": 341,
	"./prize": 343,
	"./prize.svg": 343,
	"./prize@2x": 93,
	"./prize@2x.png": 93,
	"./pro-badge": 196,
	"./pro-badge.svg": 196,
	"./pro-ribbon": 79,
	"./pro-ribbon.png": 79,
	"./pro-ribbon.svg": 475,
	"./pro@1x": 158,
	"./pro@1x.png": 158,
	"./pro@2x": 104,
	"./pro@2x.png": 104,
	"./pro@3x": 159,
	"./pro@3x.png": 159,
	"./pro_plan_icon": 160,
	"./pro_plan_icon.png": 160,
	"./salesforce": 161,
	"./salesforce.png": 161,
	"./seats-left": 344,
	"./seats-left.svg": 344,
	"./spinner": 55,
	"./spinner.svg": 55,
	"./start": 345,
	"./start.svg": 345,
	"./team": 222,
	"./team-3": 346,
	"./team-3.jpg": 346,
	"./team.svg": 222,
	"./team@2x": 105,
	"./team@2x.png": 105,
	"./team_plan_icon": 115,
	"./team_plan_icon.png": 115,
	"./team_sidebar": 162,
	"./team_sidebar.png": 162,
	"./thumbnail": 163,
	"./thumbnail.png": 163,
	"./upload-arrow": 347,
	"./upload-arrow.svg": 347,
	"./upload-cloud": 348,
	"./upload-cloud.svg": 348,
	"./upload-copy": 164,
	"./upload-copy.png": 164,
	"./upload-copy@2x": 165,
	"./upload-copy@2x.png": 165,
	"./upload-copy@3x": 166,
	"./upload-copy@3x.png": 166,
	"./upload-drop": 349,
	"./upload-drop.svg": 349,
	"./video-thumbnail": 167,
	"./video-thumbnail.png": 167,
	"./video-trim": 350,
	"./video-trim-active": 351,
	"./video-trim-active.svg": 351,
	"./video-trim.svg": 350,
	"./view-grid": 352,
	"./view-grid-active": 353,
	"./view-grid-active.svg": 353,
	"./view-grid.svg": 352,
	"./view-list": 354,
	"./view-list-active": 355,
	"./view-list-active.svg": 355,
	"./view-list.svg": 354,
	"./windows": 356,
	"./windows.svg": 356,
	"./your_plan_badge@2x": 168,
	"./your_plan_badge@2x.png": 168,
	"./zendesk": 169,
	"./zendesk.png": 169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 428;